import { Skeleton } from "primereact/skeleton"
import { ReactElement } from "react"

export const QuotationDetailsLoading = ():ReactElement => {
    return (
        <div
            id="quotation-details-panel-loading"
            data-cy="quotation-details-panel-loading"
        >
            <Skeleton shape="rectangle" height="50vh" width="100%" />
        </div>
    )
}